import React from 'react';
import { FileClock, X } from 'lucide-react';
import { draftAge } from '@/hooks/useLeadDraft';

/** Shown when an unfinished lead is saved in this browser. */
export function LeadDraftBanner({ draft, onResume, onDiscard }) {
  if (!draft) return null;
  const name = (draft.data.customer_name || '').trim();
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border-2 border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="lead-draft-banner">
      <FileClock className="w-4 h-4 text-amber-600 shrink-0" />
      <span className="flex-1 min-w-[200px]">
        You have an unfinished lead{name ? <> for <strong>{name}</strong></> : ''} saved {draftAge(draft.savedAt)}.
      </span>
      <button type="button" onClick={onResume} className="font-bold text-white bg-amber-600 hover:bg-amber-700 rounded-full px-3 py-1 text-xs" data-testid="lead-draft-resume">Resume</button>
      <button type="button" onClick={onDiscard} className="inline-flex items-center gap-1 text-xs font-semibold text-amber-800 hover:text-amber-950 px-2 py-1" data-testid="lead-draft-discard"><X className="w-3.5 h-3.5" /> Discard</button>
    </div>
  );
}
